import { DocumentStatus } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum } from '@/utils/zodUtils';

export const SetDocumentStatusSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      documentStatus: requiredEnum(DocumentStatus, t),
      annotation: z.string().nullable(),
    })
    .refine((data) => !(data.documentStatus === DocumentStatus.INCIDENCE && !data.annotation), {
      message: t('REQUIRED_FIELD'),
      path: ['annotation'],
    });

export type SetDocumentStatusType = z.infer<ReturnType<typeof SetDocumentStatusSchema>>;
